"use strict";

exports.__esModule = true;
exports.setForumData = exports.SET_FORUM_DATA = void 0;
var SET_FORUM_DATA = 'forumData/SET';
exports.SET_FORUM_DATA = SET_FORUM_DATA;

var setForumData = function setForumData(payload) {
  return {
    type: SET_FORUM_DATA,
    payload: payload
  };
};

exports.setForumData = setForumData;